import { render, staticRenderFns } from "./device_config.vue?vue&type=template&id=f1940b46&"
import script from "./device_config.vue?vue&type=script&lang=js&"
export * from "./device_config.vue?vue&type=script&lang=js&"
import style0 from "./device_config.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports